<template>
  <div
    @click="clicked"
    :class="[{ clickable: isClickable }, item?.class]"
    v-html="item?.markup || itemText"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { TableCellData } from '@/shared/models/components.model.ts';

export default defineComponent({
  props: {
    item: {
      default: null,
      type: Object as () => TableCellData | null,
    },
  },
  computed: {
    isClickable() {
      return !!this.item?.clickable;
    },
    itemText() {
      if (this.item?.text) {
        return this.item.text;
      }
      return '';
    },
  },
  methods: {
    clicked(e: MouseEvent) {
      const target = e.target as HTMLElement | null;
      if (target?.closest('#click')) {
        this.$emit('click-item');
      } else if (target?.closest('#link')) {
        this.$emit('link-item');
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.clickable {
  cursor: pointer;
}
</style>
